import { OfflineOperationsActionsModule } from './../../../+admin/+offline-operations-actions/offline-operations-actions.module';
import { OfflineSalesActionsModule } from './../../../+admin/+offline-sales/+offline-sales-actions/offline-sales-actions.module';
import { OfflineSalesModule } from './../../../+admin/+offline-sales/offline-sales.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { NgModule } from "@angular/core";
import { PopoverModule } from "ng2-popover";
import { CollapseMenuComponent } from "./collapse-menu/collapse-menu.component";
import { RecentProjectsComponent } from "./recent-projects/recent-projects.component";
import { FullScreenComponent } from "./full-screen/full-screen.component";
import { ActivitiesComponent } from "./activities/activities.component";
import { ActivitiesMessageComponent } from "./activities/activities-message/activities-message.component";
import { ActivitiesNotificationComponent } from "./activities/activities-notification/activities-notification.component";
import { ActivitiesTaskComponent } from "./activities/activities-task/activities-task.component";
import { HeaderComponent, NotifyModalComponent } from "./header.component";
import { UtilsModule } from "../../utils/utils.module";
import { SpeechButtonComponent } from './speech-button/speech-button.component';
import { I18nModule } from "../../i18n/i18n.module";
import { UserModule } from "../../user/user.module";
import { VoiceControlModule } from "../../voice-control/voice-control.module";
import { BsDropdownModule, ModalModule } from "ngx-bootstrap";
import { PhoneCallComponent } from './phone-call/phone-call.component';
import { SharedModule } from '../../shared.module';
import { RouterModule } from '@angular/router';
import { UsersActionsModule } from '../../../+admin/+users/+actions/users-actions.module';
import { NgZorroAntdModule } from 'ng-zorro-antd';
import { MomentModule } from 'angular2-moment';
// import moment from 'moment';
import * as moment from 'moment';
import 'moment/locale/es' ;
moment.locale('es');

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    VoiceControlModule,
    BsDropdownModule,
    UtilsModule,
    I18nModule,
    UserModule,
    PopoverModule,
    SharedModule,
    RouterModule,
    UsersActionsModule,
    BsDropdownModule,
    MomentModule,
    NgZorroAntdModule,
    NgSelectModule,
    OfflineSalesModule,
    OfflineSalesActionsModule,
    OfflineOperationsActionsModule,
    ModalModule.forRoot(),
  ],
  declarations: [
    ActivitiesMessageComponent,
    ActivitiesNotificationComponent,
    ActivitiesTaskComponent,
    RecentProjectsComponent,
    FullScreenComponent,
    // CollapseMenuComponent,
    ActivitiesComponent,
    HeaderComponent,
    SpeechButtonComponent,
    PhoneCallComponent,
    NotifyModalComponent
  ],
  exports: [
    HeaderComponent
  ],
  entryComponents: [NotifyModalComponent]
})
export class HeaderModule{}
